// extracted by mini-css-extract-plugin
export default {"word_box":"KeywordItem_word_box__IMM5g","text":"KeywordItem_text__sDakQ","item":"KeywordItem_item__lnGnG","list":"KeywordItem_list__2dAIs"};